import { isEmptyVal } from '@/utils';

const state = {
  openInvoiceList: [],
  openInvoiceTotalAmount: 0,
  openInvoiceCount: 0,
  currentCreditBalance: 0,
  openInvoiceOriginalTotalAmount: 0,
};

const getters = {
  openInvoiceList: (state) => state.openInvoiceList,
  openInvoiceCount: (state) => state.openInvoiceCount,
  existOpenInvoice: (state, getters) => getters.openInvoiceCount > 0,
  openInvoiceCartItemCount: (state, getters) => getters.existOpenInvoice ? 1 : 0,
  openInvoiceTotalAmount: (state) => state.openInvoiceTotalAmount,
  openInvoiceOriginalTotalAmount: (state) => state.openInvoiceOriginalTotalAmount,
  getterCurrentCreditBalance: (state) => state.currentCreditBalance,
};

const mutations = {
  setOpenInvoiceState(state, data) {
    if (isEmptyVal(data)) return;
    const { invoices = [], totalBalance = 0, totalCount = 0, creditBalance = 0 } = data;
    state.openInvoiceList = invoices;
    state.openInvoiceOriginalTotalAmount = totalBalance * 100;
    state.currentCreditBalance = creditBalance * 100;
    // only for existing open invoice, will use credit balance to cover
    if (totalBalance > 0 || invoices?.length > 0) {
      // prorated open invoice total amount (total open invoice amount - applied credit balance), credit balance is the customer unUse days amount)
      // for free account, the backend will execute the payment run, apply the credit balance to the current open invoice, so the frontend just use the totalBalance field value
      state.openInvoiceTotalAmount = totalBalance * 100;
    }
    state.openInvoiceCount = totalCount;
  },
  resetOpenInvoiceState(state) {
    state.openInvoiceList = [];
    state.openInvoiceTotalAmount = 0;
    state.openInvoiceCount = 0;
    state.currentCreditBalance = 0;
    state.openInvoiceOriginalTotalAmount = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
